function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.614 6.104l-8.623 9.142a1.225 1.225 0 01-1.766.03L2.298 10.4a1.21 1.21 0 01.063-1.658 1.242 1.242 0 011.675-.062l4.057 3.983 7.723-8.217a1.238 1.238 0 012.104.34 1.208 1.208 0 01-.305 1.317z",
  fill: "#fff"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.01,
  fill: "#fff",
  d: "M0 0h20v20H0z"
});

var SvgCheck = function SvgCheck(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M17.6144 6.10398L8.9914 15.2464C8.77196 15.4825 8.46654 15.6225 8.1426 15.6354C7.81867 15.6483 7.50288 15.533 7.26498 15.3151C7.25081 15.3025 7.23733 15.2891 7.22459 15.2751L2.29812 10.4008C1.87761 9.91704 1.90501 9.19432 2.36097 8.74313C2.81692 8.29194 3.54727 8.26482 4.03611 8.68094L8.09256 12.6636L15.8156 4.44702C16.0941 4.11008 16.5332 3.94577 16.9673 4.01598C17.4014 4.0862 17.7647 4.38027 17.9204 4.78743C18.076 5.19458 18.0003 5.65297 17.7218 5.98991C17.6893 6.03077 17.6535 6.06899 17.6149 6.10421L17.6144 6.10398Z' fill='white'/%3E %3Crect opacity='0.01' width='20' height='20' fill='white'/%3E %3C/svg%3E";
export { SvgCheck as ReactComponent };